import { render, staticRenderFns } from "./WrappingLog.vue?vue&type=template&id=225a560d"
import script from "./WrappingLog.vue?vue&type=script&lang=js"
export * from "./WrappingLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports